import React, { useState } from 'react'
import { useNavigate } from 'react-router';
import { Icon } from "@iconify/react";
import { StyledLeftButtonSection, StyledLeftProfileDisplaySection, StyledLeftProfileEmail, StyledLeftProfileEmonji, StyledLeftProfileName, StyledLeftProfileNameAndEmail, StyledLeftSectionButton, StyledLeftSectionButtonText, StyledMainPageLeftSection } from './style.sidebar';
// import { StyledManiPageContent } from '../dashboard/style.dashboard';


const Sidebar = () => {
  const [activateItem, setActivateItem] = useState('')
  const navigate = useNavigate()

  const buttonControl = (obj) => {
    setActivateItem(obj.title)
    //  console.log(activateItem,"tiltle")
    navigate(obj.urls)
  }

  // console.log(activateItem)
  const leftButtons = [
    {
      icon: <Icon icon="mdi:home" width="24" height="24" />,
      title: "Dashboard",
      urls: "/"
    },
    {
      icon: <Icon icon="material-symbols:shopping-cart-outline" width="24" height="24" />,
      title: "Tickets",
      urls: "/tickets"
    },
    {
      icon: <Icon icon="material-symbols:shopping-bag-outline" width="24" height="24" />,
      title: "Tour Packages",
      urls: "/tour-packages"
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 32 32"><path fill="currentColor"
        d="M16 5c-.214 0-.428.035-.633.104L5.025 8.55A1.5 1.5 0 0 0 4 9.973V22.89a1.5 1.5 0 0 0 1.137 1.455l10.379 2.593a2 2 0 
      0 0 .968 0l10.38-2.593A1.5 1.5 0 0 0 28 22.89V9.973c0-.646-.412-1.218-1.025-1.422L16.633 5.104A2 2 0 0 0 16 5m0 2l10 3.
      332v2.545l-9.2-2.758a2.77 2.77 0 0 0-1.6 0L6 12.877v-2.545zm0 4.633q.243 0 .482.068L26 14.56v7.94L16 25L6 22.5v-7.941l9.525-
      2.858q.232-.069.475-.068m-.78 1.373a.3.3 0 0 0-.128.004l-3.332.908a.28.28 0 0 0-.201.268v.582c0 .184.174.31.35.267l3.333-.908c
      .117-.033.2-.15.2-.275v-.575a.28.28 0 0 0-.221-.271zm1.561 0a.28.28 0 0 0-.222.271v.577c0 .133.084.242.2.275l3.333.906c.175.05.
      35-.082.35-.265v-.584a.28.28 0 0 0-.2-.266l-3.334-.908a.3.3 0 0 0-.127-.006m-6.56 1.365a.3.3 0 0 0-.13.006l-2.775.758a.276.276 0
       0 0-.207.267v.575c0 .184.175.317.35.267l2.783-.758a.28.28 0 0 0 .2-.267v-.574a.28.28 0 0 0-.221-.274m11.56 0a.28.28 0 0 0-.222.2
       74v.574c0 .125.084.234.2.267l2.784.758c.175.05.35-.084.35-.267v-.575a.28.28 0 0 0-.21-.267l-2.775-.758a.3.3 0 0 0-.127-.006"/></svg>,
      title: "Hajj & Umrah Packages",
      urls: "/hajj-umrah-packages"
    },
    {
      icon: <Icon icon="mdi:passport" width="24" height="24" />,
      title: "Passport Services",
      urls: "/passport-services"
    },
    {
      icon: <Icon icon="mdi:note-text-outline" width="24" height="24" />,
      title: "Visa Services",
      urls: "/visa-services"
    },
    {
      icon: <Icon icon="ic:outline-speaker-notes" width="24" height="24" />,
      title: "Enquiries",
      urls: "/enquiries"
    }
  ]
  return (
    <>

        <StyledMainPageLeftSection>
          <StyledLeftProfileDisplaySection>
            <StyledLeftProfileEmonji><span><Icon icon="fluent-emoji:person-light" width="45" height="45" /></span></StyledLeftProfileEmonji>
            <StyledLeftProfileNameAndEmail>
              <StyledLeftProfileName>Nihal avulan</StyledLeftProfileName>
              <StyledLeftProfileEmail>ceo@gamil.com</StyledLeftProfileEmail>
            </StyledLeftProfileNameAndEmail>
          </StyledLeftProfileDisplaySection>
          <StyledLeftButtonSection>
            {
              leftButtons.map((obj) => (

                <StyledLeftSectionButton isActivated={activateItem === obj.title ? true : false} onClick={() => buttonControl(obj)}>

                  <span>{obj.icon}</span>
                  <StyledLeftSectionButtonText>{obj.title}</StyledLeftSectionButtonText>

                </StyledLeftSectionButton>
              ))
            }
          </StyledLeftButtonSection>
        </StyledMainPageLeftSection>

    </>
  )
}

export default Sidebar
// {() => {navigate(obj.urls);setActivateItem(obj.title)}}